export default __webpack_public_path__ + "static/media/Abharana_Logo.efa037fe.svg";